export default __webpack_public_path__ + "static/media/2855.7abe2824.png";